import { useMutation } from "@tanstack/react-query";
import { createRapidFireBatch } from "../services/rapidFireService";

export function useRapidFireBatchCreate(options = {}) {
  return useMutation({
    mutationFn: (data) => createRapidFireBatch(data),
    ...options,
  });
}
